
(function() {
  var overlay = document.querySelector('[data-js-search-overlay]');
  if (!overlay) return;
  var input = overlay.querySelector('[data-js-search-input]');
  var results = overlay.querySelector('[data-js-search-results]');
  var closeBtn = overlay.querySelector('[data-js-search-close]');
  var emptyHTML = results ? results.innerHTML : '';
  var searchTimeout = null;
  var searchAbort = null;
  var searchRevision = 0;
  var opener = null;
  var focusTimeout = null;
  var scrollPosition = 0;
  var previousBodyTop = '';
  var searchUrl = window.jsqSearchCfg.u;
  var searchCurrency = window.jsqSearchCfg.c;
  var fromPrice = window.jsqSearchCfg.p;

  function cancelSearch() {
    clearTimeout(searchTimeout);
    searchRevision++;
    if (searchAbort) searchAbort.abort();
    searchAbort = null;
    activeIdx = -1;
    input.removeAttribute('aria-activedescendant');
    input.setAttribute('aria-expanded', 'false');
  }
  function showResults(html) {
    results.innerHTML = html;
    markOptions();
    input.setAttribute('aria-expanded', opts().length ? 'true' : 'false');
  }
  function searchPrice(product) {
    var value = Number(product.price);
    if (!Number.isFinite(value)) return '';
    var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:searchCurrency}).format(value);
    return Number(product.price_min) < Number(product.price_max) ? fromPrice.replace('__PRICE__', formatted) : formatted;
  }

  function escHTML(s) {
    return String(s).replace(/[&<>"']/g, function(m) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];
    });
  }

  function openOverlay() {
    if (overlay.getAttribute('data-open') === 'true' || window.innerWidth > 768) return;
    cancelSearch();
    opener = document.activeElement;
    scrollPosition = window.scrollY;
    previousBodyTop = document.body.style.top;
    document.body.style.top = '-' + scrollPosition + 'px';
    overlay.setAttribute('data-open', 'true');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-js-lock', 'true');
    if (input) {
      results.innerHTML = emptyHTML;
      focusTimeout = setTimeout(function() { if (overlay.getAttribute('data-open') !== 'true') return; input.focus(); var q = input.value.trim(); if (q.length >= 2) runSearch(q); }, 60);
    }
  }
  function closeOverlay(restoreFocus) {
    if (overlay.getAttribute('data-open') !== 'true') return;
    cancelSearch();
    clearTimeout(focusTimeout);
    overlay.removeAttribute('data-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.removeAttribute('data-js-lock');
    document.body.style.top = previousBodyTop;
    window.scrollTo(0, scrollPosition);
    if (restoreFocus !== false && opener && opener.isConnected && !opener.disabled && opener.getClientRects().length &&
        window.getComputedStyle(opener).visibility !== 'hidden') opener.focus();
  }

  window.jsqSearchOverlay = { open: openOverlay, close: closeOverlay };
  window.addEventListener('resize', function() {
    if (window.innerWidth > 768) closeOverlay(false);
  });

  document.querySelectorAll('[data-js-app-bar-search-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openOverlay();
    }, true);
  });
  document.querySelectorAll('.js-mobile-tabs a[data-tab="search"], .mbn a[href="/search"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
        e.preventDefault();
        openOverlay();
      }
    });
  });
  if (closeBtn) closeBtn.addEventListener('click', function(e){ e.preventDefault(); closeOverlay(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.getAttribute('data-open') === 'true') { e.preventDefault(); closeOverlay(); }
  });

  overlay.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab' || overlay.getAttribute('data-open') !== 'true') return;
    var focusable = [].slice.call(overlay.querySelectorAll('input:not([type="hidden"]), button, a[href]')).filter(function(el) { return !el.disabled && el.getClientRects().length; });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  overlay.querySelector('form').addEventListener('submit', cancelSearch);

  function runSearch(q) {
    if (/^(?:24[\s\-\/]*(?:6|six)|twenty\s+four\s+six)(?:\s+player)?$/i.test(q)) q = '24Six';
    var revision = searchRevision;
    searchAbort = new AbortController();
    var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(q) +
              '&resources%5Btype%5D=product%2Ccollection%2Carticle' +
              '&resources%5Blimit%5D=8' +
              '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
              '&resources%5Boptions%5D%5Bfields%5D=title%2Cvendor%2Cproduct_type%2Cvariants.title%2Cvariants.sku%2Cbody%2Cvariants.barcode';
    fetch(url, { signal: searchAbort.signal, headers: { 'Accept': 'application/json' } })
      .then(function(r) { if (!r.ok) throw new Error('Search request failed'); return r.json(); })
      .then(function(data) {
        if (revision !== searchRevision || overlay.getAttribute('data-open') !== 'true') return;
        var r = (data && data.resources && data.resources.results) || {};
        var products = r.products || [];
        var collections = r.collections || [];
        var articles = r.articles || [];
        if (!products.length && !collections.length && !articles.length) {
          results.innerHTML = '<p class="js-search-overlay__no-results">No matches for &ldquo;' + escHTML(q) + '&rdquo;.<br><a href="' + escHTML(searchUrl) + '?q=' + encodeURIComponent(q) + '">Open full search →</a></p>';
          markOptions();
          announce('No results for ' + q);
          return;
        }
        var html = '';
        if (products.length) {
          html += '<p class="js-search-overlay__section">Products</p>';
          products.forEach(function(p) {
            html += '<a class="js-search-overlay__row" href="' + escHTML(p.url || '#') + '">' +
              (p.image ? '<img class="js-search-overlay__row-img" src="' + escHTML(p.image) + '" alt="" role="presentation" loading="lazy">' : '<span class="js-search-overlay__row-img"></span>') +
              '<span class="js-search-overlay__row-body">' +
              '<p class="js-search-overlay__row-title">' + escHTML(p.title || '') + '</p>' +
              '<p class="js-search-overlay__row-meta">' +
                (p.vendor ? '<span>' + escHTML(p.vendor) + '</span>' : '') +
                (p.price ? '<strong>' + escHTML(searchPrice(p)) + '</strong>' : '') +
              '</p>' +
              '</span>' +
              '</a>';
          });
        }
        if (collections.length) {
          html += '<p class="js-search-overlay__section">Collections</p>';
          collections.forEach(function(c) {
            html += '<a class="js-search-overlay__row" href="' + escHTML(c.url || '#') + '">' +
              '<span class="js-search-overlay__row-img" style="display:grid;place-items:center;" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9C7C44" stroke-width="1.7"><path d="M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg></span>' +
              '<span class="js-search-overlay__row-body">' +
              '<p class="js-search-overlay__row-title">' + escHTML(c.title || '') + '</p>' +
              '</span>' +
              '</a>';
          });
        }
        if (articles.length) {
          html += '<p class="js-search-overlay__section">Articles</p>';
          articles.forEach(function(a) {
            html += '<a class="js-search-overlay__row" href="' + escHTML(a.url || '#') + '">' +
              '<span class="js-search-overlay__row-img" style="display:grid;place-items:center;" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9C7C44" stroke-width="1.7"><path d="M2 4h7a3 3 0 0 1 3 3v13a2.5 2.5 0 0 0-2.5-2.5H2z"/><path d="M22 4h-7a3 3 0 0 0-3 3v13a2.5 2.5 0 0 1 2.5-2.5H22z"/></svg></span>' +
              '<span class="js-search-overlay__row-body">' +
              '<p class="js-search-overlay__row-title">' + escHTML(a.title || '') + '</p>' +
              '</span>' +
              '</a>';
          });
        }
        html += '<a class="js-search-overlay__viewall" href="' + escHTML(searchUrl) + '?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + escHTML(q) + '&rdquo; →</a>';
        showResults(html);
        var totalHits = products.length + collections.length + articles.length;
        announce(totalHits + (totalHits === 1 ? ' suggestion. ' : ' suggestions. ') + 'Use arrow keys to review.');
      })
      .catch(function(err) {
        if (revision !== searchRevision || overlay.getAttribute('data-open') !== 'true' || (err && err.name === 'AbortError')) return;
        results.innerHTML = '<p class="js-search-overlay__no-results">Search unavailable. <a href="' + escHTML(searchUrl) + '?q=' + encodeURIComponent(q) + '">Open full search →</a></p>';
      });
  }


  /* SPRINT4.5: keyboard support, ArrowUp/Down move through results, Enter opens,
     aria-activedescendant tracks the highlighted option, counts announced politely. */
  var activeIdx = -1;
  function announce(msg) {
    var s = document.getElementById('status-announcement');
    if (s) { s.textContent = ''; setTimeout(function(){ s.textContent = msg; }, 50); }
  }
  function opts() { return [].slice.call(results.querySelectorAll('.js-search-overlay__row')); }
  function markOptions() {
    opts().forEach(function(a, i){ a.id = 'js-so-opt-' + i; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false'); });
    activeIdx = -1;
    if (input) input.removeAttribute('aria-activedescendant');
  }
  function setActive(i) {
    var o = opts();
    if (!o.length) return;
    if (activeIdx > -1 && o[activeIdx]) { o[activeIdx].classList.remove('is-active'); o[activeIdx].setAttribute('aria-selected', 'false'); }
    activeIdx = Math.max(0, Math.min(i, o.length - 1));
    var el = o[activeIdx];
    el.classList.add('is-active');
    el.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', el.id);
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }
  if (input) {
    input.addEventListener('keydown', function(e) {
      var o = opts();
      if (e.key === 'ArrowDown' && o.length) { e.preventDefault(); setActive(activeIdx + 1); }
      else if (e.key === 'ArrowUp' && o.length) { e.preventDefault(); setActive(activeIdx - 1); }
      else if (e.key === 'Enter' && activeIdx > -1 && o[activeIdx]) { e.preventDefault(); e.stopImmediatePropagation(); window.location.assign(o[activeIdx].href); }
    }, true);
  }

  if (input) {
    input.addEventListener('input', function() {
      var q = this.value.trim();
      if (/^(?:24[\s\-\/]*(?:6|six)|twenty\s+four\s+six)(?:\s+player)?$/i.test(q)) {
        q = '24Six';
        this.value = '24Six';
      }
      cancelSearch();
      results.innerHTML = emptyHTML;
      if (q.length < 2) {
        results.innerHTML = emptyHTML;
        return;
      }
      searchTimeout = setTimeout(function() { runSearch(q); }, 180);
    });
  }
})();
